import Vue from 'vue'
import App from './App.vue'
import router from './router'
import TalkToUsButton from "./components/common/TalkToUsButton";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFacebook, faLinkedin } from "@fortawesome/fontawesome-free-brands";
import vClickOutside from 'vue-click-outside'
import VueScrollTo from 'vue-scrollto'

import '@/assets/styles/reset.css'
import '@/assets/styles/main.scss'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'
library.add(fas, faFacebook, faLinkedin);

Vue.use(vClickOutside)
Vue.use(VueScrollTo)


Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('talk-to-us-button', TalkToUsButton)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
